/**
 * 科研常量文件
 */

export const ky_constant = {

	/**
	 * 纵向项目模块ID
	 */
	PORTRAIT_MODULE: { key: "2100", value: '纵向项目模块' },

	/**
 * 纵向立项模块
 */
	PORTRAIT_DECLARE_MODULE: { key: "210001", value: '纵向立项模块' },

	/**
	 * 纵向变更模块
	 */
	PORTRAIT_ALTERATION_MODULE: { key: "210002", value: '纵向变更模块' },

	/**
	 * 纵向结项模块
	 */
	PORTRAIT_COMPLETE_MODULE: { key: "210003", value: '纵向结项模块' },

	/**
	 * 横向项目模块ID
	 */
	TRANSVERSE_MODULE: { key: "2200", value: '横向项目模块ID' },

	/**
* 横向签审模块
*/
	TRANSVERSE_SIGN_MODULE: { key: "220001", value: '横向签审模块' },

	/**
* 横向立项模块
*/
	TRANSVERSE_DECLARE_MODULE: { key: "220002", value: '横向立项模块' },

	/**
	 * 横向变更模块
	 */
	TRANSVERSE_ALTERATION_MODULE: { key: "220003", value: '横向变更模块' },

	/**
	 * 横向结项模块
	 */
	TRANSVERSE_COMPLETE_MODULE: { key: "220004", value: '横向结项模块' },


	/**
	 * 校级项目模块ID
	 */
	SCHOOL_PROJECT_MODULE: { key: "2200", value: '校级项目模块ID' },

	/**
* 校级立项模块
*/
	SCHOOL_PROJECT_DECLARE_MODULE: { key: "230001", value: '校级立项模块' },

	/**
	 * 校级变更模块
	 */
	SCHOOL_PROJECT_ALTERATION_MODULE: { key: "230002", value: '校级变更模块' },

	/**
	 * 校级结项模块
	 */
	SCHOOL_PROJECT_COMPLETE_MODULE: { key: "230003", value: '校级结项模块' },

	/**
 * 校级中检模块
 */
	SCHOOL_PROJECT_INSPECT_MODULE: { key: "230004", value: '校级中检模块' },


	/**
	 * 经费模块ID
	 */
	FUNDS_MODULE: { key: "3100", value: '经费模块' },

	/**
	 * 成果模块ID
	 */
	ACHIEVEMENTS_MODULE: { key: "4100", value: '成果模块' },

	/**
 * 论文模块ID
 */
	ACHIEVEMENTS_PAPER_MODULE: { key: "410001", value: '论文模块' },

	/**
* 著作模块ID
*/
	ACHIEVEMENTS_BOOK_MODULE: { key: "410002", value: '著作模块' },

	/**
* 研究报告模块ID
*/
	ACHIEVEMENTS_REPORT_MODULE: { key: "410003", value: '研究报告模块' },

	/**
* 艺术作品模块ID
*/
	ACHIEVEMENTS_REPORT_MODULE: { key: "410004", value: '艺术作品模块' },

	/**
* 著作权模块ID
*/
	ACHIEVEMENTS_COPYRIGHT_MODULE: { key: "410005", value: '著作权模块' },

	/**
* 专利模块ID
*/
	ACHIEVEMENTS_PATENT_MODULE: { key: "410006", value: '专利模块' },

	/**
* 获奖模块ID
*/
	ACHIEVEMENTS_HONOR_MODULE: { key: "410007", value: '获奖模块' },


	/**
	 * 数据完备常量
	 */
	MAIN_COMPLETE_DATA: { key: "1501", value: '数据完备' },

	/**
	 * 数据不完备常量
	 */
	MAIN_IMCOMPLETE_DATA: { key: "1502", value: '数据不完备' },

	/**
	 * 审核状态常量 - 已提交
	 */
	SUBMITTED: { key: "1601", value: '已提交' },

	/**
	 *审核状态常量 - 学院通过
	 */
	DEPARTMENT_PASSED: { key: "1602", value: '学院通过' },

	/**
	 * 审核状态常量 - 学校通过
	 */
	SCHOOL_PASSED: { key: "1603", value: '学校通过' },

	/**
	 * 审核状态常量 - 学院退回
	 */
	DEPARTMENT_RETURNED: { key: "1604", value: '学院退回' },

	/**
	 * 审核状态常量 - 学校退回
	 */
	SCHOOL_RETURNED: { key: "1605", value: '学校退回' },

	/**
	 * 审核状态常量 - 暂存
	 */
	TEMPORARY: { key: "1606", value: '暂存' },

	/**
	 * 审核状态常量 - 待完善
	 */
	IMPROVING: { key: "1607", value: '待完善' },

	/**
	 * 审核状态常量 - 待确认
	 */
	CONFIRMING: { key: "1608", value: '待确认' },

	/**
	 *审核状态常量 - 作废
	 */
	REPEAL: { key: "1609", value: '作废' },


	/**
	 * 项目状态 - 进行
	 */
	PROJECT_CONDUCT: { key: "2001", value: '进行' },

	/**
	 * 项目状态 - 暂存
	 */
	PROJECT_TEMPORARY: { key: "2002", value: '暂存' },

	/**
	 * 项目状态 - 撤销
	 */
	PROJECT_REVOKE: { key: "2003", value: '撤销' },

	/**
	 * 项目状态 - 完成
	 */
	PROJECT_END: { key: "2005", value: '完成' },

	/**
	 * 项目状态 - 结项
	 */
	PROJECT_COMPLETE: { key: "2004", value: '结项' },

	/**
	 *项目状态常量 - 作废
	 */
	pPROJECT_REPEAL: { key: "2006", value: '作废' },

	/**
	 * 项目状态常量 - 变更
	 */
	PROJECT_CHANGE: { key: "2007", value: '变更' },

	/**
* 项目状态常量 - 未启动
*/
	APPLY_WAITING: { key: "2010", value: '变更' },

	/**
 * 项目状态常量 - 启动
 */
	APPLY_STARTING: { key: "2011", value: '启动' },

	/**
* 项目状态常量 - 已停止
*/
	APPLY_STOPPED: { key: "2012", value: '已停止' },



	/**
	 * 预算变更
	 */
	BUDGET_CHANGE: "budgetChange",

	/**
 * 成员变更
 */
	MEMBER_CHANGE: "memberChange",

	/**
 * 负责人变更
 */
	CHARGER_CHANGE: "chargerChange",

	/**
 * 延期变更
 */
	TIME_CHANGE: "timeChange",

	/**
 * 终止变更
 */
	STOP_CHANGE: "stopChange",
}













